/**
 * Zona aproximada de cobertura del PMTiles provincial (IDECOR 406).
 * bbox: [minLng, minLat, maxLng, maxLat] — alineado con provinceClickBounds (Córdoba).
 */
export const CORDOBA_PROVINCE_COVERAGE_BBOX = [-66.8, -35.2, -61.7, -29.4];

export function isInCordobaProvinceCoverage([lng, lat]) {
  const [west, south, east, north] = CORDOBA_PROVINCE_COVERAGE_BBOX;
  return (
    Number.isFinite(lng)
    && Number.isFinite(lat)
    && lng >= west
    && lng <= east
    && lat >= south
    && lat <= north
  );
}

/**
 * Indica si el viewport del mapa se superpone con un bbox [west, south, east, north].
 * @param {import('maplibre-gl').Map} map
 * @param {[number, number, number, number]} bbox
 */
export function viewportIntersectsBbox(map, bbox) {
  if (!map || !bbox) return false;
  const bounds = map.getBounds();
  const [west, south, east, north] = bbox;
  return !(
    bounds.getEast() < west
    || bounds.getWest() > east
    || bounds.getNorth() < south
    || bounds.getSouth() > north
  );
}
